<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12 15.4-2.4 1.5-.4.1-.3-.1-.2-.3v-.4l.6-2.8-2.1-2-.2-.3v-.3q0-.2.2-.3l.3-.2 2.9-.2 1-2.7.3-.3.3-.1h.3l.2.4 1.1 2.7 2.9.2.3.2.2.3v.3l-.2.3-2.1 2 .6 2.8v.4l-.2.3-.3.1h-.4z"
    />
    <path
      d="M12 4a8 8 0 0 0-6 2.8q-.3.3 0 .7l1 1.1q.4.8-.3.9H2.5L2 9V4.7q.1-.8.9-.3l1 1q.3.2.7-.1A10 10 0 0 1 22 11.5q0 .5-.5.5h-1l-.5-.5A8 8 0 0 0 12 4m-8.5 8q.5 0 .5.5a8 8 0 0 0 14 4.7q.3-.3 0-.7l-1-1.1q-.5-.8.3-.9h4.3q.5 0 .5.5v4.3q-.1.7-.9.3l-1-1-.7.1A10 10 0 0 1 2 12.5q0-.5.5-.5z"
    />
  </svg>
</template>
